
import React from "react";
import { Clock } from "lucide-react";

const DayInLifeSection: React.FC = () => {
  const timelineItems = [
    {
      time: "7:30 AM",
      title: "Morning Without Interruptions",
      description: "Check today's schedule with your coffee. No more urgent parent texts about makeup classes.",
      highlight: "Parents schedule their own makeup classes through the portal — no texts needed.",
      bgColor: "bg-[#FDE1D3]"
    },
    {
      time: "10:15 AM",
      title: "Zero Billing Questions",
      description: "Focus on teaching while parents access their accounts and payment history themselves.",
      highlight: "Parents view detailed payment histories and make payments online anytime.",
      bgColor: "bg-[#E5DEFF]"
    },
    {
      time: "2:45 PM",
      title: "Effortless Updates",
      description: "Send a quick notification about schedule changes that reaches all affected families instantly.",
      highlight: "Updates and notifications go directly to parents' phones — no individual calls.",
      bgColor: "bg-[#FFDEE2]"
    },
    {
      time: "6:30 PM",
      title: "Evening is Actually Yours",
      description: "Run reports while your child plays. No after-hours parent calls about basic information.",
      highlight: "Parents check class details, documents, and policies on their own — anytime, anywhere.",
      bgColor: "bg-[#F2FCE2]"
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
            Reclaim Your Day with Hivetivity
          </h2>
          <p className="text-xl text-gray-600">
            How would your day change when parents handle their own questions?
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          {timelineItems.map((item, index) => (
            <div key={index} className="relative mb-12 last:mb-0">
              {/* Timeline connector */}
              {index < timelineItems.length - 1 && (
                <div className="absolute left-7 top-14 bottom-0 w-0.5 bg-gray-200 z-0"></div>
              )}
              
              <div className="flex gap-6">
                {/* Time circle */}
                <div className="flex-shrink-0 relative z-10">
                  <div className="h-14 w-14 rounded-full bg-white flex items-center justify-center shadow-md border border-gray-100">
                    <Clock className="h-6 w-6 text-[#FA8C00]" />
                  </div>
                  <div className="text-sm font-medium text-gray-500 text-center mt-1">
                    {item.time}
                  </div>
                </div>
                
                {/* Content */}
                <div className={`flex-grow p-6 rounded-2xl shadow-md ${item.bgColor} bg-opacity-30`}>
                  <h3 className="text-xl font-bold text-gray-800 mb-2">{item.title}</h3>
                  <p className="text-gray-700 mb-3">{item.description}</p>
                  <p className="text-sm italic bg-white bg-opacity-70 p-2 rounded-lg inline-block">
                    "{item.highlight}"
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DayInLifeSection;
